import React, {useRef, useState} from "react";
import {useNavigate}      from "react-router-dom";

import useMobile      from "../../hooks/useMobile";
import {FundoSistema} from "../../assets/style";
import Menu           from "../../components/menu";

const Sistema = () => {
    const aviso = useRef(null);
    const navegacao = useNavigate();
    const {isMobile} = useMobile();
    const [senha, setSenha] = useState('');
    const margem = isMobile ? 0 : 2;

    return (
        <FundoSistema>
            <Menu/>
        </FundoSistema>
    );
}

export default Sistema;